import {isAnonymous} from 'topmeteo/utils/html';

import {ScrollDirection, ComputeStyle} from '../ScrollWatch';
import {PanelHeight, ScrollingElement} from '../base';

import Headers from './Headers';

const defaultTop = isAnonymous ? 40 : 0;

const horizontalScroll = ({scrollTop}) => ({
    position: 'absolute',
    left: 0,
    top: scrollTop,
});

const verticalScroll = ({scrollLeft}, panelOpen) => ({
    position: 'fixed',
    left: -scrollLeft,
    top: defaultTop + (panelOpen ? PanelHeight.open : PanelHeight.closed),
});

const getComputedStyle = ({scrollDirection, node, panelOpen}) => (
    scrollDirection === ScrollDirection.vertical
        ? verticalScroll(node, panelOpen)
        : horizontalScroll(ScrollingElement)
);

const Wrapper = props => (
    <ComputeStyle {...props} getComputedStyle={getComputedStyle}>
        <Headers />
    </ComputeStyle>
);

export default Wrapper;
